var map = {
	"./Base": 201,
	"./Base/": 201,
	"./Base/config": 845,
	"./Base/config.js": 845,
	"./Base/index": 201,
	"./Base/index.js": 201,
	"./Base/style": 173,
	"./Base/style.js": 173,
	"./Clutch": 495,
	"./Clutch/": 495,
	"./Clutch/index": 495,
	"./Clutch/index.js": 495,
	"./Clutch/style": 1137,
	"./Clutch/style.js": 1137,
	"./NewUi": 496,
	"./NewUi/": 496,
	"./NewUi/index": 496,
	"./NewUi/index.js": 496,
	"./NewUi/style": 1138,
	"./NewUi/style.js": 1138,
	"./OldUi": 497,
	"./OldUi/": 497,
	"./OldUi/index": 497,
	"./OldUi/index.js": 497,
	"./OldUi/style": 1139,
	"./OldUi/style.js": 1139,
	"./SpireonNew": 498,
	"./SpireonNew/": 498,
	"./SpireonNew/index": 498,
	"./SpireonNew/index.js": 498,
	"./SpireonNew/style": 1140,
	"./SpireonNew/style.js": 1140,
	"./SpireonOld": 499,
	"./SpireonOld/": 499,
	"./SpireonOld/index": 499,
	"./SpireonOld/index.js": 499,
	"./SpireonOld/style": 1141,
	"./SpireonOld/style.js": 1141
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1972;
module.exports = webpackAsyncContext;